/**
 * Bill Payments selector functions
 */
import { createSelector } from 'reselect';

const billPaymentsReducer = (state) => state.get('billPaymentsReducer');

/**
 * Retrieves loading state from bill payments reducer
 */
export const loadingSelector = createSelector(billPaymentsReducer, (state) =>
  state.get('loading'),
);

/**
 * Retrieves error state from bill payments reducer
 */
export const errorSelector = createSelector(billPaymentsReducer, (state) =>
  state.get('error'),
);

/**
 * Retrieves bil payment state from bill payments reducer
 */
export const billPaymentSelector = createSelector(
  billPaymentsReducer,
  (state) => state.get('billPayment').toJS(),
);

/**
 * Retrieves bill payments state from bill payments reducer
 */
export const billPaymentsSelector = createSelector(
  billPaymentsReducer,
  (state) => state.get('billPayments').toJS(),
);

/**
 * Retrieves count state from bill payments reducer
 */
export const countSelector = createSelector(billPaymentsReducer, (state) =>
  state.get('count'),
);
